<template>
  <el-tabs v-model="type" type="border-card" @tab-click="tabClick">
    <el-tab-pane name="0" label="筛查摘要配置">
      <component-summary ref="summary0" :configType="0"/>
    </el-tab-pane>
    <el-tab-pane name="1" label="慢病摘要配置">
      <component-summary ref="summary1" :configType="1"/>
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import componentSummary from "./components/summary.vue";
export default {
  components: {
    componentSummary
  },
  data() {
    return {
      type: "0"
    }
  },
  mounted() {
    this.$refs.summary0.getList();
  },
  methods: {
    tabClick() {
      this.$refs[`summary${this.type}`].getList();
    }
  }
}
</script>
